// KPI — Prodotti (3), Prezzi e sconti (5)
import React, { useState } from "react";
import { Tag, Percent } from "lucide-react";
import { useFm, fmtKg, fmtInt, Seg } from "../bi/biShared";
import { Kpi, Group, KpiGrid, RankList, SubTitle, fmtPct, fmtNum } from "./kpiShared";

const SORTS = [{ value: "revenue", label: "Fatturato" }, { value: "kg", label: "Kg" }, { value: "customers_count", label: "Clienti" }, { value: "purchase_frequency", label: "Frequenza" }];

export default function KpiProducts({ data }) {
  const fm = useFm();
  const F = data.formulas;
  const p = data.products, pr = data.prices;
  const [sort, setSort] = useState("revenue");
  const [dev, setDev] = useState("below");
  const rows = [...p.rows].sort((a, b) => (b[sort] ?? -1) - (a[sort] ?? -1)).slice(0, 25);
  const devRows = dev === "below" ? pr.below_ref : pr.above_ref;
  return (
    <div className="space-y-4" data-testid="kpi-tab-products">
      <Group num={3} title="Prodotti" icon={Tag} note={`${data.notes.ddt} ${F.share} ${F.freq}`} testId="kpi-g3">
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <p className="text-xs text-stone-500" data-testid="kpi-prod-summary">{fmtInt(p.count)} articoli · {fm(p.total_revenue)}</p>
          <Seg options={SORTS} value={sort} onChange={setSort} testIdPrefix="kpi-prod-sort" size="sm" />
        </div>
        <RankList rows={rows} label={(x) => x.description || x.code}
          sub={(x) => `${x.code} · ${fmtKg(x.kg, 1)} kg · ${x.avg_price != null ? `${fm(x.avg_price)}/kg` : "—"} · ${fmtInt(x.customers_count)} clienti · freq. ${fmtNum(x.purchase_frequency, 2)}`}
          value={(x) => fm(x.revenue)} right={(x) => `quota ${fmtPct(x.share_pct)}`} testIdPrefix="kpi-prod" />
      </Group>

      <Group num={5} title="Prezzi e sconti" icon={Percent} testId="kpi-g5">
        <KpiGrid cols={3}>
          <Kpi label="Sconto medio" value={fmtPct(pr.discount_pct)} sub={`${fm(pr.discount_total)} di sconto`} formula={F.discount} testId="kpi-price-discount" accent />
          <Kpi label="Prezzo teorico" value={fm(pr.list_total)} formula={F.list_total} testId="kpi-price-list" />
          <Kpi label="Netto fatturato" value={fm(pr.net_total)} formula={F.revenue} testId="kpi-price-net" />
        </KpiGrid>
        <SubTitle>Variabilità del prezzo per articolo</SubTitle>
        <RankList rows={pr.variability.slice(0, 8)} label={(x) => x.description || x.code}
          sub={(x) => `${x.code} · min ${fm(x.min_price)} · max ${fm(x.max_price)} · ${fmtInt(x.lines)} righe`}
          value={(x) => `± ${fm(x.stdev)}/kg`} right={(x) => `CV ${fmtPct(x.cv_pct)} · medio ${fm(x.avg_price)}`} testIdPrefix="kpi-price-var" emptyLabel="Servono almeno 2 righe per articolo" />
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <SubTitle>Differenza prezzo vs riferimento</SubTitle>
          <Seg options={[{ value: "below", label: "Sotto la media" }, { value: "above", label: "Sopra la media" }]} value={dev} onChange={setDev} testIdPrefix="kpi-price-dev" size="sm" />
        </div>
        <p className="text-[11px] text-stone-500">{F.dev_ref}</p>
        <RankList rows={devRows} label={(x) => x.customer} sub={(x) => `${x.description || x.code} · ${fmtKg(x.kg, 1)} kg · rif. ${fm(x.ref_price)}/kg`}
          value={(x) => `${fm(x.price)}/kg`} right={(x) => `${x.diff > 0 ? "+" : ""}${fm(x.diff)} (${fmtPct(x.diff_pct)}) · ${fm(x.impact)}`} testIdPrefix={`kpi-price-${dev}`} />
        <SubTitle>Prezzo medio per cliente</SubTitle>
        <RankList rows={pr.by_customer.slice(0, 10)} label={(x) => x.name} sub={(x) => `${fmtKg(x.kg, 1)} kg · ${fm(x.revenue)}`} value={(x) => `${fm(x.avg_price_kg)}/kg`} testIdPrefix="kpi-price-cust" />
      </Group>
    </div>
  );
}
